import { cloneDeep, get } from 'lodash';

import { UPDATE_STUDENT } from 'PointOfSale/state/types';

import * as types from './types';

export const INITIAL_STATE = {
  currentProfile: {
    profile: {
      symbolIndicator: [],
      Balance: 0,
    },
  },
  lastTransactionProfile: {},
  previousAmountPaid: 0,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_STUDENT: {
      const newState = { ...state };

      if (get(state, 'lastTransactionProfile.IdSeed') === payload.idSeed) {
        newState.lastTransactionProfile = {
          ...newState.lastTransactionProfile,
          ...payload.update,
        };
      }

      if (get(state, 'currentProfile.profile.IdSeed') === payload.idSeed) {
        newState.currentProfile.profile = {
          ...newState.currentProfile.profile,
          ...payload.update,
        };
      }

      return newState;
    }
    case types.SET_PROFILE:
      return {
        ...state,
        currentProfile: {
          profile: payload,
        },
      };
    case types.SERVING_SET_IS_OPEN_SYMBOL:
      let newSymbols = cloneDeep(state.currentProfile.profile.symbolIndicator);
      if (payload.index > newSymbols.length - 1) {
        return state;
      }

      newSymbols[payload.index].isOpen = payload.isOpen;
      return {
        ...state,
        currentProfile: {
          ...state.currentProfile,
          profile: {
            ...state.currentProfile.profile,
            symbolIndicator: newSymbols,
          },
        },
      };
    case types.SERVING_SET_SYMBOLS_IS_OPEN: {
      if (payload.length === 0) {
        return state;
      }
      let newSymbols = cloneDeep(state.currentProfile.profile.symbolIndicator);
      payload.forEach(symbol => {
        newSymbols[symbol.index].isOpen = symbol.isOpen;
      });

      return {
        ...state,
        currentProfile: {
          ...state.currentProfile,
          profile: {
            ...state.currentProfile.profile,
            symbolIndicator: newSymbols,
          },
        },
      };
    }
    case types.UPDATE_PROFILE_PREVIOUS_AMOUNT_PAID:
      return { ...state, previousAmountPaid: payload };
    case types.SERVING_SET_IS_INVALID_STUDENT_SELECTED:
      return {
        ...state,
        isInvalidStudentSelected: payload,
      };
    case types.UPDATE_PROFILE_BALANCE:
      return {
        ...state,
        currentProfile: {
          ...state.currentProfile,
          profile: {
            ...state.currentProfile.profile,
            Balance: payload,
          },
        },
      };
    case types.CLEAR_CURRENT_PROFILE:
      return {
        ...state,
        currentProfile: {
          profile: {
            symbolIndicator: [],
            Balance: 0,
          },
        },
      };
    case types.SET_CURRENT_PROFILE:
      return {
        ...state,
        currentProfile: payload,
      };
    case types.SET_LAST_TRANSACTION_PROFILE:
      return {
        ...state,
        lastTransactionProfile: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/state/reducer.js